module.exports = __webpack_public_path__ + "static/media/cosplay0.d8ab0ecb.jpg";